import { Employer } from './Employer';
import { Check } from './Check';
import { Task } from './../../task/models/Task';
export class Valutazione  extends Task {
  nominativo: string;
  indirizzo: string;
  cap: string;
  citta: string;
  provincia: string;
  nazione: string;
  email: string;
  pec: string;
  fax: string;
  telefono: string;
  codice_univoco: string;
  piva: string;
  cf: string;
  checks: Check[];
  employers: Employer[];
  regione: string;
  files: any;
  constructor(){
    super()
    this.checks = [];
    this.employers = [];
  }
}
